import Vue from "vue"
import Vuetify from "vuetify/lib"

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        primary: "#DFC79B",
        secondary: "#CC8556",
        accent: "#35606F",
        error: "#3C807E"
      }
    }
  }
})
